import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    offlineBannerTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title shown when user loses internet connection */
            offlineBannerTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NetworkStatusBanner.offlineBannerTitle?c=3s46jl6pri0y4", defaultMessage: "Looks like you''re offline" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
